module.exports = __webpack_public_path__ + "img/letrasSIM-HI.c58092b8.png";